/**
 * applyTimeZoneToDate - Internal helper function to apply a time zone offset to a given date
 */
function applyTimeZoneToDate(date, timeZone) {
  if (isNaN(Date.parse(date))) {
    throw new Error("'".concat(date, "' is not a valid Date"));
  } // Convert the given time zone offset in hours to milliseconds (multiply by 3600000),
  // then add this to the parsed representation of the given date in milliseconds and create a new Date object


  return new Date(Date.parse(date) + 3600000 * timeZone);
}
/**
 * adjustDateByTimeZone - Takes a given date and applies a given time zone, adjusting for browser's time zone
 *
 * @param  {string} isoDateString - Date string in ISO format, e.g., 2017-01-16T09:59:00.000Z
 * @param  {Number} timeZone - Represents the project time zone offset from GMT in hours, e.g., -5
 * @return {Object} Date object stripped of browser time zone with given time zone applied
 */


function adjustDateByTimeZone(isoDateString, timeZone) {
  if (isNaN(Date.parse(isoDateString))) {
    throw new Error("'".concat(isoDateString, "' is not a valid Date"));
  }

  var dateObject = new Date(isoDateString); // First remove the browser's timezone from the new Date
  // Don't switch the sign of the offset--the return value is already backwards
  // getTimezoneOffset() returns the offset from GMT in minutes. Divide by 60 to get the offset in hours.

  var browserTimeZone = dateObject.getTimezoneOffset() / 60;
  dateObject = applyTimeZoneToDate(dateObject, browserTimeZone); // Now apply the desired time zone

  dateObject = applyTimeZoneToDate(dateObject, timeZone);
  return dateObject;
}

/**
 * Compares if the two dates are equal.
 * Assumes that the dates provided to create the instances of Date are in UTC format
 */
function areTwoDatesEqual(date1, date2) {
  var date1Part = date1.toISOString().split('T')[0];
  var date2Part = date2.toISOString().split('T')[0];
  return date1Part === date2Part;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/**
 * Parse an ISO formatted  date in the local timezone
 * @param dateString
 */
function parseLocalISODate(dateString) {
  var _dateString$split = dateString.split(/\D/),
      _dateString$split2 = _slicedToArray(_dateString$split, 6),
      year = _dateString$split2[0],
      month = _dateString$split2[1],
      day = _dateString$split2[2],
      _dateString$split2$ = _dateString$split2[3],
      hour = _dateString$split2$ === void 0 ? 0 : _dateString$split2$,
      _dateString$split2$2 = _dateString$split2[4],
      minute = _dateString$split2$2 === void 0 ? 0 : _dateString$split2$2,
      _dateString$split2$3 = _dateString$split2[5],
      second = _dateString$split2$3 === void 0 ? 0 : _dateString$split2$3;

  return new Date(year, month - 1, day, hour, minute, second);
}
/**
 * Parse an ISO formatted date to a UTC data
 * @param dateString
 */

function parseUTCDate(dateString) {
  var _dateString$split3 = dateString.split(/\D/),
      _dateString$split4 = _slicedToArray(_dateString$split3, 6),
      year = _dateString$split4[0],
      month = _dateString$split4[1],
      day = _dateString$split4[2],
      _dateString$split4$ = _dateString$split4[3],
      hour = _dateString$split4$ === void 0 ? 0 : _dateString$split4$,
      _dateString$split4$2 = _dateString$split4[4],
      minute = _dateString$split4$2 === void 0 ? 0 : _dateString$split4$2,
      _dateString$split4$3 = _dateString$split4[5],
      second = _dateString$split4$3 === void 0 ? 0 : _dateString$split4$3;

  return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
}
/**
 * Format a JS Date to an ISO8061 string that can reliably be deserialized into a JS Date. This means it must follow the
 * format "YYYY-MM-DD HH:mm:ss". The time of the date produced will always by 00:00:00.
 * @param date
 * @returns {*}
 */

function formatDateToLocalISOString(date) {
  // Adjust for browser timezone offset
  var adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  var str = adjustedDate.toISOString(); // Remove time separator and Z from end of string (signifying UTC timezone) and zero out time

  return "".concat(str.slice(0, 10), " 00:00:00");
}
/**
 * Format a JS Date to an ISO8061 string that can reliably be deserialized into a JS Date. This means it must follow the
 * format "YYYY-MM-DD HH:mm:ss".
 * @param date
 * @returns {*}
 */

function formatDateTimeToLocalISOString(date) {
  // Adjust for browser timezone offset
  var adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  var str = adjustedDate.toISOString(); // Remove time separator and Z from end of string (signifying UTC timezone) and zero out time

  return "".concat(str.slice(0, 10), " ").concat(str.slice(11, 19));
}

var DateInput =
/*#__PURE__*/
function () {
  /**
   * Constructor
   * @param date JS Date object
   * @param statusCode status code for date validity
   * @param dateText text user input for date
   */
  function DateInput(date, statusCode, dateText) {
    _classCallCheck(this, DateInput);

    this.date = date;
    this.statusCode = statusCode;
    this.dateText = dateText;
  }

  _createClass(DateInput, [{
    key: "toJSON",
    value: function toJSON() {
      // Serialize to a timezone-less ISO8601 date/time, e.g. "YYYY-MM-DD HH:mm:ss"
      // This is the only format that javascript implementations consistently parse as a local date/time (instead of UTC)
      if (!this.date) {
        return null;
      }

      return formatDateToLocalISOString(this.date);
    }
  }]);

  return DateInput;
}();

var DateTimeInput =
/*#__PURE__*/
function (_DateInput) {
  _inherits(DateTimeInput, _DateInput);

  /**
   * Constructor
   * @param date JS Date object for just the date
   * @param dateText text user input for date
   * @param timeText text user input for time, shape of { hour, minute, second }
   * @param dateTime JS Date object for the combined date and time
   */
  function DateTimeInput(date, statusCode, dateText, timeText, dateTime) {
    var _this;

    _classCallCheck(this, DateTimeInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateTimeInput).call(this, date, statusCode, dateText));
    _this.timeText = timeText;
    _this.dateTime = dateTime;
    return _this;
  }

  _createClass(DateTimeInput, [{
    key: "toJSON",
    value: function toJSON() {
      // Serialize to a timezone-less ISO8601 date/time, e.g. "YYYY-MM-DD HH:mm:ss"
      // This is the only format that javascript implementations consistently parse as a local date/time (instead of UTC)
      if (!this.dateTime) {
        return null;
      }

      return formatDateTimeToLocalISOString(this.dateTime);
    }
  }]);

  return DateTimeInput;
}(DateInput);

/**
 * Formats a javascript date object into a string.
 *
 * @param date {Date} The date to format.
 * @param format {string} The format string. mm = month with 0, M = month, m = month,
 *   dd = day with 0, D = day, d = day, Y = 2 digit year, yy = 4 digit year, yyyy = 4 digit year
 * @return {Object} The date properly formatted as a string.
 */
function formatDateToString(date, format) {
  var selectedFormat = format;
  selectedFormat = selectedFormat.replace(/M/, date.getMonth() + 1);
  selectedFormat = selectedFormat.replace(/D/, date.getDate());
  selectedFormat = selectedFormat.replace(/Y/, date.getFullYear() % 1000);
  selectedFormat = selectedFormat.replace(/mm/, ('0' + (date.getMonth() + 1)).slice(-2));
  selectedFormat = selectedFormat.replace(/m/, date.getMonth() + 1);
  selectedFormat = selectedFormat.replace(/dd/, ('0' + date.getDate()).slice(-2));
  selectedFormat = selectedFormat.replace(/d/, date.getDate());
  selectedFormat = selectedFormat.replace(/yyyy/, date.getFullYear());
  selectedFormat = selectedFormat.replace(/yy/, date.getFullYear());
  return selectedFormat;
}

/**
 * Formats a date string into a javascript date object. (Only month/day/year or day/month/year formats)
 *
 * @param dateString {string} The date to format. If null, this function will throw an exception.
 * @param format {string} optional. The format string. Defaults to assuming a month/day/year format.
 *      mm = month with 0, dd = day with 0, yy = 4 digit year, M = month, D = day, Y = 2 digit year.
 *      The year part must come at the last.
 *      The three parts (day, month, year) must be separated by either a slash (/) or a dash (-).
 *      Slashes and dashes cannot be mixed (e.g. mm-dd/yy is invalid).
 *      Examples of valid format: mm-dd-yy, dd/mm/yy, D/M/Y, M/D/Y.
 * @return {Object} The date properly formatted as a string as per the format provided. Will return
 *      null if the input is deemed to be invalid.
 */
function getDateFromString(dateString, format) {
  var inputStringArray = dateString.split('/');

  if (inputStringArray.length !== 3) {
    inputStringArray = dateString.split('-');
  } // Make sure there are three parts to the date, and make sure the year is either 2 or 4 digits.


  if (inputStringArray.length !== 3 || inputStringArray[2].length !== 2 && inputStringArray[2].length !== 4) {
    return null;
  }

  var monthIndex = 0;
  var dayIndex = 1;

  if (format && (format.indexOf('D') === 0 || format.indexOf('dd') === 0)) {
    monthIndex = 1;
    dayIndex = 0;
  }

  var month = Number(inputStringArray[monthIndex]);
  var day = Number(inputStringArray[dayIndex]);
  var year = Number(inputStringArray[2]); // Make sure the month, day, and year exist.

  if (!month || !day || !year) {
    return null;
  } // Adjust two digit years if necessary.


  if (year < 50) {
    year += 2000;
  } else if (year < 100) {
    year += 1900;
  } // Create the date object.


  var newDate = new Date(year, month - 1, day); // Checks to see if month and day are valid.

  if (newDate.getDate() !== day || newDate.getMonth() !== month - 1) {
    return null;
  }

  return newDate;
}

/**
 * Checks and returns a common date format separator
 * @param {string} format - can be a formatted date string or a date format
 * @return {string}
 **/
function getSeparator(format) {
  if (format.indexOf('/') !== -1) {
    return '/';
  }

  if (format.indexOf('-') !== -1) {
    return '-';
  }

  if (format.indexOf('.') !== -1) {
    return '.';
  }

  return false;
}
/**
 * IE11 adds hidden characters when converting a date to string
 * This function strips a value of any hidden charaters
 * @param {string} value
 * @return {string}
 **/

function stripHiddenChars(value) {
  return value.replace(/[^\x00-\x7F]/g, '');
}
/**
 * Builds and returns a date format.
 * Also sets the day, month, and year indexes
 * Uses an array that has been split by a separator
 * @param {string} - formattedDateString
 * @param {string} - separator
 * @return {string}
 **/

function getFormatFromDateArray(formattedDateString, separator) {
  var dateArray = formattedDateString.split(separator);
  var localeDateFormat = '';

  if (dateArray.length >= 3) {
    dateArray.forEach(function (chunk, index) {
      switch (stripHiddenChars(chunk)) {
        case '1':
          localeDateFormat += 'd';
          break;

        case '01':
          localeDateFormat += 'dd';
          break;

        case '2':
          localeDateFormat += 'm';
          break;

        case '02':
          localeDateFormat += 'mm';
          break;

        case '03':
          localeDateFormat += 'yy';
          break;

        case '2003':
          localeDateFormat += 'yyyy';
          break;

        default:
          break;
      }

      if ((index < 2 || index === 3) && localeDateFormat) {
        localeDateFormat += separator;
      }
    });
  }

  return localeDateFormat;
}
/**
 * Returns the locale date string format
 * This function creates a known date and then uses a separator to split the date string
 * From there it can determine the order of the locale's date format
 * If no date format can be found then we default to mm/dd/yyyy
 * @param {string} - locale
 * @return {string}
 **/


function getLocaleDateString(locale, options) {
  var knownDate = new Date(2003, 1, 1);
  var formattedDateString = new Intl.DateTimeFormat(locale, options).format(knownDate).replace(/\s/g, '');
  var separator = getSeparator(formattedDateString);

  if (!separator) {
    return false;
  }

  var localeDateFormat = getFormatFromDateArray(formattedDateString, separator);

  if (localeDateFormat.indexOf('d') === -1 || localeDateFormat.indexOf('m') === -1 || localeDateFormat.indexOf('y') === -1) {
    localeDateFormat = 'mm/dd/yyyy';
  }

  return localeDateFormat;
}

// Memorizing the results by locale
var formats = {};
/**
 * Returns an object containing time formatting information based on local.
 * This function creates a known time, and matches it with a regex.
 * Defaults to 24 hour format, with colon as the separator b/w hours and minutes.
 * @param {string} - locale
 * @return {object}
 **/

function getLocaleTimeFormat(locale) {
  if (formats[locale]) return formats[locale];
  var format; // The first capturing group captures text matching hours, 14 or 2 or 02.
  // The second capturing group captures separator if it exists.
  // The last capturing group stores periods, e.g. AM, PM, or p.m.

  var regex = new RegExp('^(14|2|02)(\\W)?30\\s*(.*?)$');
  var options = {
    hour: '2-digit',
    minute: '2-digit'
  };
  var afternoonTime = new Date(2003, 1, 1, 14, 30);
  var morningTime = new Date(2003, 1, 1, 2, 30);

  var getCapturingGroups = function getCapturingGroups(time) {
    // IE11 adds hidden characters when converting a date to string. .replace(/[^\x00-\x7F]/g, '') strips them out.
    // $FlowIssue Not recognizing Intl as a built-in 0bject object https://github.com/facebook/flow/issues/2801
    var formattedTimeString = new Intl.DateTimeFormat(locale, options).format(time).replace(/[^\x00-\x7F]/g, '');
    return formattedTimeString.match(regex);
  };

  var afternoonTimeArray = getCapturingGroups(afternoonTime); // separator defaults to ":"

  var separator = afternoonTimeArray && afternoonTimeArray[2] || ':';
  var hours = afternoonTimeArray && afternoonTimeArray[1];
  var afterNoonLabel = afternoonTimeArray && afternoonTimeArray[3];
  var morningTimeArray = getCapturingGroups(morningTime);
  var beforeNoonLabel = morningTimeArray && morningTimeArray[3];

  if (hours && parseInt(hours, 10) === 2 && afterNoonLabel && beforeNoonLabel) {
    format = {
      separatorSymbol: separator,
      use24hours: false,
      periodConfig: {
        beforeNoonLabel: beforeNoonLabel,
        beforeNoonKey: beforeNoonLabel[0].toLocaleLowerCase(),
        afterNoonLabel: afterNoonLabel,
        afterNoonKey: afterNoonLabel[0].toLocaleLowerCase()
      }
    };
  } else {
    format = {
      separatorSymbol: separator,
      use24hours: true
    };
  }

  formats[locale] = format;
  return format;
}

/**
 * Returns an array of localized names for 12 months, starting from January
 *
 * @param locale {string}
 * @param format {string} - the representation of the name, possible values are "short" or "long"
 * @return {Array} - array of localized names for 12 months, starting from January.
 */
var months = {};
function getMonthNames(locale) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'short';
  if (months[locale] && months[locale][format]) return months[locale][format];
  if (!months[locale]) months[locale] = {};
  months[locale][format] = [];
  var d = new Date(2012, 0, 1);

  for (var i = 0; i < 12; i++) {
    d.setMonth(i);
    months[locale][format].push(new Intl.DateTimeFormat(locale, {
      month: format
    }).format(d));
  }

  return months[locale][format];
}

/**
 * Returns an array of localized names in a week, starting from Sunday
 *
 * @param locale {string}
 * @param format {string} - the representation of the name, possible values are "short" or "long"
 * @return {Array} - array of localized names starting from Sunday.
 */
var weekdays = {};
function getWeekdayNames(locale) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'short';

  if (weekdays[locale] && weekdays[locale][format]) {
    return weekdays[locale][format];
  }

  if (!weekdays[locale]) weekdays[locale] = {};
  weekdays[locale][format] = [];
  var d = new Date(2017, 0, 15);
  var baseDate = d.getDate() - d.getDay();

  for (var i = 0; i < 7; i++) {
    d.setDate(baseDate + i);
    weekdays[locale][format].push(new Intl.DateTimeFormat(locale, {
      weekday: format
    }).format(d));
  }

  return weekdays[locale][format];
}

var MOBILE_DATE_STRING_REGEX = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;
/**
 * HTML5 date inputs (used by mobile) always return their value as a string
 * of the form {(4 digit year)-(month with leading 0)-(day with leading 0)}.
 * This function will parse that string into a date object with a zero'ed out
 * time component.
 * @param {string} dateString - an html5 formatted mobile date string.
 * @returns {Date} A new Date object with the specified year, month, day of the string.
 */

function parseMobileDateString(dateString) {
  if (!dateString || !MOBILE_DATE_STRING_REGEX.test(dateString)) {
    return null;
  }

  var stringArray = dateString.split('-');
  var year = parseInt(stringArray[0], 10);
  var month = parseInt(stringArray[1], 10) - 1;
  var day = parseInt(stringArray[2], 10);
  return new Date(year, month, day);
}

/**
 * Returns a date given a string. Returns null if input cannot be paresed into a valid date.
 * @param {string} - string to be converted into a date
 * @param {string} - format the conversion bases on
 * @return {date}
 **/

function resolveDateFromString(dateString) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mm/dd/yyyy';
  var separator = getSeparator(format);
  var inputStringArray = dateString.split(separator);

  if (inputStringArray.length < 3) {
    return null;
  } // Set values for day, month and year


  var month;
  var day;
  var year;
  var formatArray = format.split(separator);

  if (formatArray.length < inputStringArray.length) {
    return null;
  }

  formatArray.forEach(function (c, index) {
    var chunk = stripHiddenChars(c);
    var input = stripHiddenChars(inputStringArray[index]);

    if (chunk === 'd' || chunk === 'dd') {
      day = input.length > 2 || input.length === 2 && input[1] === '.' ? null : Number(input);
    } else if (chunk === 'm' || chunk === 'mm') {
      month = input.length > 2 || input.length === 2 && input[1] === '.' ? null : Number(input);
    } else if (chunk === 'yy') {
      year = input.length !== chunk.length ? null : Number(input); // Adjust two digit years if necessary.

      if (year && year < 50) {
        year += 2000;
      } else if (year && year < 100) {
        year += 1900;
      }
    } else if (chunk === 'yyyy') {
      year = input.length !== chunk.length ? null : Number(input);
    }
  }); // Make sure the month, day, and year exist.

  if (!month || !day || !year || year.toString().length < 4) {
    return null;
  } // Create the date object.


  var newDate = new Date(year, month - 1, day); // Checks to see if month and day are valid.

  if (newDate.getDate() !== day || newDate.getMonth() !== month - 1) {
    return null;
  }

  return newDate;
}

var EMPTY_DATE = Symbol('empty_date');
var EMPTY_DATE_AND_TIME = Symbol('empty_date_and_time');
var DATE_CHANGE_SUCCESS = 'DATE_CHANGE_SUCCESS';
var DATE_CHANGE_EMPTY_DATE = 'DATE_CHANGE_EMPTY_DATE';
var DATE_CHANGE_ERROR_INVALID = 'DATE_CHANGE_ERROR_INVALID';
var DATE_CHANGE_ERROR_OUT_OF_RANGE = 'DATE_CHANGE_ERROR_OUT_OF_RANGE';
var START_DATE_CHANGED = 'START_DATE_CHANGED';
var END_DATE_CHANGED = 'END_DATE_CHANGED';

export { adjustDateByTimeZone, areTwoDatesEqual, DateInput, DateTimeInput, formatDateToString, getDateFromString, stripHiddenChars, getSeparator, getLocaleDateString, getLocaleTimeFormat, getMonthNames, getWeekdayNames, parseMobileDateString, resolveDateFromString, parseLocalISODate, parseUTCDate, formatDateToLocalISOString, formatDateTimeToLocalISOString, EMPTY_DATE, EMPTY_DATE_AND_TIME, DATE_CHANGE_SUCCESS, DATE_CHANGE_EMPTY_DATE, DATE_CHANGE_ERROR_INVALID, DATE_CHANGE_ERROR_OUT_OF_RANGE, START_DATE_CHANGED, END_DATE_CHANGED };
//# sourceMappingURL=index.js.map
